import Mixin from '@/mixins/DocumentMixin';
const m = new Mixin();

export default {
  orderDocTypeId(context) {
    return m.orderDocTypeIds[m.getDocType(context.$route.path)];
  },
  priv(context) {
    return m.privs[m.getDocType(context.$route.path)];
  },
  overviewTitle(context) {
    return m.overviewTitles[m.getDocType(context.$route.path)];
  },
  detailTitle(context) {
    return m.detailTitles[m.getDocType(context.$route.path)];
  },
  deleteTitle(context) {
    return m.deleteTitles[m.getDocType(context.$route.path)];
  },
  url(context) {
    return m.getURL(context.$route.path);
  },
  fixedFilter(context) {
    return m.getFixedFilter(context);
  },
  apiUrl: '/orderdocs/',
  sortBy: ['created_timestamp'],
  sortDesc: [true],
  deletable: true,
  editable: true,
  filterName(context) {
    return m.getFilterName(context);
  },
  quickFilter: {
    text: 'Zoeken',
    value: 'misc_search',
    type: 'text'
  },
  advancedSearchFields: [
    {
      text: 'Project',
      value: 'project_id',
      type: 'optionList',
      optionListName: 'projects'
    },
    {
      text: 'Klant',
      value: 'project_businessrelation_id',
      type: 'optionList',
      optionListName: 'businessrelations'
    },
    {
      text: 'Periode van',
      value: 'creationdate_ge',
      type: 'date'
    },
    {
      text: 'Periode tot',
      value: 'creationdate_le',
      type: 'date'
    }
  ],
  newRecord(context) {
    return {
      is_architect: false,
      orderdoctype_id: m.orderDocTypeIds[m.getDocType(context.$route.path)],
      supplier_id: 1,
      groups: [],
      lines: [],
      customer_id: 1,
      terms: m.termDefaults[m.getDocType(context.$route.path)],
      warranty_remarks: m.warrantyDefaults[m.getDocType(context.$route.path)],
      insurance_percentage: 0
    };
  },
  tableFields(context) {
    if (m.getDocType(context.$route.path) === 'templates') {
      return [
        {
          text: 'Naam',
          value: 'info',
          link: m.getURL(context.$route.path, '{id}'),
          sortable: false,
          width: '80%'
        }
      ];
    } else {
      return [
        {
          text: 'Nummer',
          value: 'docnr',
          link: m.getURL(context.$route.path, '{id}'),
          sortable: false,
          width: '10%'
        },
        {
          text: 'Datum',
          value: 'creationdate',
          width: '10%',
          filter: 'date'
        },
        m.getRelationColumn(context.$route.path),
        {
          text: 'Projectnummer',
          value: 'project_code',
          link: '/projects/{project_id}',
          width: '15%'
        },
        {
          text: 'Bedrag (excl.)',
          value: 'amount_exclusive',
          filter: 'euro',
          sortable: false,
          width: '10%'
        },
        {
          text: 'Bedrag (incl.)',
          value: 'amount_inclusive',
          filter: 'euro',
          sortable: false,
          width: '10%'
        },
        {
          text: 'Bestand',
          value: 'file',
          type: 'file',
          width: '15%',
          align: 'center',
          sortable: false
        }
      ];
    }
  },
  // customEditable(item) {
  //   return !item.is_locked;
  // },
  customDeletable(item) {
    return !item.is_locked;
  }
};
